import * as React from 'react';

import styles from './ImageWithTextMessageLayout.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { ChatMessageBubble } from '../../../ChatMessageBubble';
import { ChatMessage } from '../../../ChatMessage';
import { MetaRow } from '../MetaRow';

interface IImageWithTextMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  imageMessage: React.ReactNode;
  textMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  actionButtons: React.ReactNode;
  userColor?: EUserColor;
  replyQuote: React.ReactNode | null;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const ImageWithTextMessageLayout = React.forwardRef<HTMLDivElement, IImageWithTextMessageLayoutProps>(
  function ImageWithTextMessageLayout(
    {
      errorSign,
      errorText,
      messageType,
      isLastMessageInChain,
      imageMessage,
      textMessage,
      messageMeta,
      actionButtons,
      userColor,
      replyQuote,
      highlighted,
      onHighlightEnd,
    },
    ref,
  ) {
    return (
      <ChatMessage errorSign={errorSign} errorText={errorText} className={styles['image-with-text-message__row']}>
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['image-with-text-message__bubble']}
          ref={ref}
          userColor={userColor}
          highlighted={highlighted}
          onHighlightEnd={onHighlightEnd}
        >
          <div className={styles['image-with-text-message__quote']}>{replyQuote}</div>
          {imageMessage}
          <div className={styles['text-message']}>{textMessage}</div>
          <div className={styles['action-buttons']}>{actionButtons}</div>
          <MetaRow messageType={messageType} className={styles['image-with-text-message__meta']} userColor={userColor}>
            {messageMeta}
          </MetaRow>
        </ChatMessageBubble>
      </ChatMessage>
    );
  },
);
